import apiClient from "@/api/api-client";

export const fetchCorrectionData = async (page = 1, limit = 15) => {
  const { data } = await apiClient.get("/correction", {
    params: { page, limit },
  });
  return data;
};

export const saveCorrection = async (batch_id, text) => {
  const { data } = await apiClient.post("/correction", {
    action: "edit",
    batch_id,
    text,
  });
  return data;
};

export const deleteCorrectionRow = async (batch_id) => {
  const { data } = await apiClient.post("/correction", {
    action: "delete",
    batch_id,
  });
  return data;
};

export const getCorrectionExportList = async () => {
  const { data } = await apiClient.get("/correction/export");
  return data;
};

export const exportCorrectionFile = async (payload) => {
  const { data } = await apiClient.post("/correction/export", payload);
  return data;
};

export const deleteCorrectionFile = async (filename) => {
  const { data } = await apiClient.delete("/correction", {
    data: { filename },
  });
  return data;
};
